import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Show skeleton briefly on initial mount
    const timer = setTimeout(() => {
      setLoading(false);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <footer className="footer-skeleton">
        <div className="footer-skeleton-logo"></div>
        <div className="footer-skeleton-text"></div>
        <div className="footer-skeleton-tagline"></div>
        <div className="footer-skeleton-links">
          <div className="footer-skeleton-link"></div>
          <div className="footer-skeleton-link"></div>
          <div className="footer-skeleton-link"></div>
        </div>
        <div className="footer-skeleton-text" style={{ width: '250px', height: '14px', marginTop: '20px' }}></div>
      </footer>
    );
  }

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <img src="/Logo.png" alt="David Goodman Prime Time Logo" className="footer-logo" />
          <span className="footer-name">David Goodman - Prime Time</span>
          <p className="footer-tagline">Track & Field Analysis, Rising Stars & Record-Breaking Moments</p>
        </div>
        
        <nav className="footer-nav">
          <Link to="/" className="footer-link">Home</Link>
          <Link to="/about" className="footer-link">About</Link>
          <Link to="/contact-us" className="footer-link">Contact Us</Link>
        </nav>
        
        <div className="footer-copyright">
          <p>&copy; {new Date().getFullYear()} David Goodman - Prime Time. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
